

import React from "react"


/**
 * Region West svg icon with defined properties as per UI
 * @returns WestSvg JSX
 */

export const WestSvg = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="26" height="26" />
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3418 10.5938L7.8125 5.81454L17.3418 1.09361L15.7099 5.81454L17.3418 10.5938ZM9.67188 5.84936L14.5385 5.84936L15.4128 8.73438L9.67188 5.84936Z" fill="#717171" />
            <path d="M8.33547 23.6571L5 12H7.69228L9.62184 20.0996H9.71861L11.8474 12H14.1526L16.2757 20.1167H16.3782L18.3077 12H21L17.6645 23.6571H15.2625L13.0427 16.0356H12.9516L10.7375 23.6571H8.33547Z" fill="#717171" />
        </svg>
    )
}
